import {AfterViewInit, Component} from '@angular/core';
import {AppService} from '../../services/app.service';

declare const $;

@Component({
  selector: 'pm-buy-now',
  templateUrl: './buy-now.component.html',
  styleUrls: ['./buy-now.component.scss']
})
export class BuyNowComponent implements AfterViewInit {

  constructor(
    private app: AppService
  ) {
    app.setTitle('Buy Now');
  }

  ngAfterViewInit(): void {
    // ------------step-wizard-------------
    $(document).ready(() => {
      $('.nav-tabs > li a[title]').tooltip();

      // Wizard
      $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {

        const target = $(e.target);

        if (target.parent().hasClass('disabled')) {
          return false;
        }
      });

      $('.next-step').click((e) => {

        const active = $('.wizard .nav-tabs li.active');
        active.next().removeClass('disabled');
        nextTab(active);

      });
      $('.prev-step').click((e) => {

        const active = $('.wizard .nav-tabs li.active');
        prevTab(active);

      });
    });

    function nextTab(elem): void {
      $(elem).next().find('a[data-toggle="tab"]').click();
    }

    function prevTab(elem): void {
      $(elem).prev().find('a[data-toggle="tab"]').click();
    }


    $('.nav-tabs').on('click', 'li', (e) => {
      $('.nav-tabs li.active').removeClass('active');
      $(e.target).addClass('active');
    });

    // ==================================== Select DropDown Js ====================================
    $(document).ready(() => {
      $('select').niceSelect();
    });
  }

}
